// this file is autogenerated in pipelines, version is either git tag or commit hash
export const RELEASE_VERSION = '';
